import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

const LoginDebug = () => {
  const [logs, setLogs] = useState([]);

  const addLog = (msg) => {
    setLogs(prev => [...prev, `[${new Date().toLocaleTimeString()}] ${msg}`]);
  };

  const testLogin = async () => {
    setLogs([]);
    try {
      addLog('Starting login test...');
      addLog(`API URL: ${API_BASE}`);
      
      const response = await axios.post(`${API_BASE}/auth/login`, {
        email: 'Ralph@canihavemoney.com',
        password: 'Canihavemoney123!',
        role: 'iso'
      });
      
      addLog('✅ Login API Response received');
      addLog(`Success: ${response.data.success}`);
      addLog(`Token exists: ${!!response.data.token}`);
      addLog(`User: ${response.data.user?.email}`);
      
      // Save to localStorage
      localStorage.setItem('mcaToken', response.data.token);
      localStorage.setItem('mcaUser', JSON.stringify(response.data.user));
      addLog('✅ Saved to localStorage');
      
      // Verify
      const savedToken = localStorage.getItem('mcaToken');
      const savedUser = localStorage.getItem('mcaUser');
      addLog(`Token in storage: ${!!savedToken}`);
      addLog(`User in storage: ${!!savedUser}`);
      
      addLog('✅ ALL CHECKS PASSED - Redirecting in 2 seconds...');
      
      setTimeout(() => {
        window.location.href = '/submitted-deals';
      }, 2000);
      
    } catch (error) {
      addLog(`❌ ERROR: ${error.message}`);
      addLog(`Status: ${error.response?.status}`);
      addLog(`Response: ${JSON.stringify(error.response?.data)}`);
    }
  };

  const clearStorage = () => {
    localStorage.clear();
    addLog('✅ LocalStorage cleared');
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Login Debug Tool</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-4">
          <div className="flex gap-4 mb-4">
            <Button onClick={testLogin} className="bg-orange-500 hover:bg-orange-600">
              Test Login
            </Button>
            <Button onClick={clearStorage} variant="outline">
              Clear Storage
            </Button>
            <Button onClick={() => setLogs([])} variant="outline">
              Clear Logs
            </Button>
          </div>
          
          <div className="border rounded p-4 bg-gray-50 h-96 overflow-y-auto">
            <pre className="text-sm font-mono">
              {logs.length === 0 ? 'Click "Test Login" to start...' : logs.join('\n')}
            </pre>
          </div>
        </div>
        
        <div className="bg-blue-50 border border-blue-200 rounded p-4">
          <h3 className="font-semibold mb-2">Instructions:</h3>
          <ol className="list-decimal list-inside space-y-1 text-sm">
            <li>Click "Clear Storage" first</li>
            <li>Click "Test Login"</li>
            <li>Watch the logs to see what happens</li>
            <li>If successful, you'll be redirected automatically</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default LoginDebug;
